import { Link, Outlet } from 'react-router-dom';

import logo from '@dmp/assets/icons/logo-colorful.svg';
import { ROUTE_PATHS } from '@dmp/constant';

import { AppLayoutFooter } from '../_share_/AppLayoutFooter/AppLayoutFooter';

export const PolicyLayout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-[#f2f5fa] px-4">
      <header className="flex justify-between items-center py-[14px] px-3 bg-white rounded-[10px] mt-[12px] mb-[22px]">
        <Link to={ROUTE_PATHS.LANDING_PAGE} className="brand-logo">
          <img src={logo} alt="logo" className="h-[40px]" />
        </Link>
      </header>
      <div>
        <Outlet />
      </div>
      <AppLayoutFooter />
    </div>
  );
};
